module.exports = __webpack_public_path__ + "img/9-text.7b67503d.png";